export const SCHEMAS = {
  players: {
    label: "Player",
    columns: [
      ["name", "Name"],
      ["position", "Pos"],
      ["club", "Club"],
      ["list_type", "List"],
      ["era", "Era"],
      ["total_score", "Score"],
    ],
    empty: {
      name: "",
      position: "MID",
      club: "",
      league: "",
      region: "Europe",
      list_type: "historic",
      dob: "",
      nationality: "Kenya",
      bio: "",
      appearances: 0,
      goals: 0,
      assists: 0,
      caps: 0,
      national_goals: 0,
      stats_source: "",
      career: [],
      scores: { league_strength: 0, prestige: 0, titles: 0, impact: 0 },
      rank: null,
      featured: false,
      published: true,
      instagram: "",
      youtube: "",
      x_url: "",
      facebook: "",
      linkedin: "",
      tiktok: "",
      transfermarkt_url: "",
      wikipedia_url: "",
      market_value: "",
    },
    fields: [
      { key: "name", label: "Full name", type: "text", required: true },
      { key: "position", label: "Position", type: "select", options: ["GK", "DEF", "MID", "FWD"] },
      { key: "club", label: "Current club", type: "text" },
      { key: "league", label: "League", type: "text" },
      { key: "region", label: "Region", type: "select", options: ["England", "Europe", "USA"] },
      {
        key: "list_type",
        label: "List type",
        type: "select",
        options: [
          ["historic", "Historic"],
          ["ones_to_watch", "Ones to Watch"],
          ["hall_of_fame", "AI Top 20 Hall of Fame"],
        ],
      },
      { key: "dob", label: "Date of birth", type: "text", placeholder: "YYYY-MM-DD" },
      { key: "era", label: "Era (period archived under)", type: "select", options: ["Before 1990", "1990–1999", "2000–2009", "2010–2019", "2020–present"] },
      { key: "rank", label: "Rank (Top 20 only)", type: "number" },
      { key: "bio", label: "Biography", type: "textarea", span: 2 },
      { key: "appearances", label: "Appearances", type: "number" },
      { key: "goals", label: "Goals", type: "number" },
      { key: "assists", label: "Assists", type: "number" },
      { key: "national_goals", label: "International goals", type: "number" },
      { key: "stats_source", label: "Stats source", type: "text" },
      { key: "caps", label: "Caps", type: "number" },
      { key: "scores.league_strength", label: "League Strength (/25)", type: "number" },
      { key: "scores.prestige", label: "Prestige (/20)", type: "number" },
      { key: "scores.titles", label: "Titles Won (/20)", type: "number" },
      { key: "scores.impact", label: "Impact (/15)", type: "number" },
      { key: "market_value", label: "Market value (Transfermarkt)", type: "text", placeholder: "€1.2m" },
      { key: "portrait_url", label: "Portrait image URL (Wikipedia)", type: "text", span: 2 },
      { key: "portrait_credit", label: "Portrait credit", type: "text", span: 2 },
      { key: "transfermarkt_url", label: "Transfermarkt URL", type: "text", span: 2 },
      { key: "wikipedia_url", label: "Wikipedia URL (leave blank to hide)", type: "text", span: 2 },
      { key: "instagram", label: "Instagram URL", type: "text" },
      { key: "x_url", label: "X URL", type: "text" },
      { key: "facebook", label: "Facebook URL", type: "text" },
      { key: "linkedin", label: "LinkedIn URL", type: "text" },
      { key: "tiktok", label: "TikTok URL", type: "text" },
      { key: "youtube", label: "Highlights URL", type: "text" },
      { key: "career", label: "Career timeline", type: "timeline", span: 2 },
      { key: "featured", label: "Featured on homepage", type: "switch" },
      { key: "published", label: "Published", type: "switch" },
    ],

  },
  news: {
    label: "Story",
    columns: [
      ["title", "Title"],
      ["game", "Game"],
      ["category", "Category"],
      ["date", "Date"],
      ["published", "Live"],
    ],
    empty: { title: "", category: "Update", game: "Professional Game", source_url: "", sources: [], verified: false, verification_note: "", excerpt: "", body: "", date: "", plan_order: 0, featured: false, published: true },
    fields: [
      { key: "title", label: "Headline", type: "text", required: true, span: 2 },
      { key: "game", label: "Game", type: "select", options: ["Professional Game", "National Game"] },
      { key: "category", label: "Category", type: "select", options: ["Stadiums", "Facilities", "Clubs", "Partnerships", "Fixtures", "Results", "Transfers", "Project Update", "Partners", "Ones to Watch", "Women in Football", "Hall of Fame", "Grassroots", "Key Observations", "Update"] },
      { key: "plan_order", label: "Milestone number (0 = general news)", type: "number" },
      { key: "date", label: "Date", type: "text", placeholder: "YYYY-MM-DD" },
      { key: "source_url", label: "Source URL", type: "text", span: 2 },
      { key: "verified", label: "Sources checked online", type: "switch" },
      { key: "verification_note", label: "Verification note", type: "textarea", span: 2 },
      { key: "excerpt", label: "Standfirst", type: "textarea", span: 2 },
      { key: "body", label: "Body (HTML supported)", type: "richtext", span: 2 },
      { key: "featured", label: "Featured", type: "switch" },
      { key: "published", label: "Published", type: "switch" },
    ],

  },
  plans: {
    label: "Plan",
    columns: [
      ["order", "#"],
      ["title", "Title"],
      ["status", "Label"],
      ["target", "Target"],
    ],
    empty: { title: "", summary: "", body: "", order: 0, status: "Step 1", target: "", published: true, milestone_headline: "", goal_amount: 0, goal_label: "", kpl_alignment: "", revenue_note: "" },
    fields: [
      { key: "title", label: "Step title", type: "text", required: true },
      { key: "order", label: "Step number", type: "number" },
      { key: "status", label: "Label", type: "text", placeholder: "Step 1" },
      { key: "target", label: "Indicative cost", type: "text", placeholder: "$832,000 est" },
      { key: "milestone_headline", label: "Step headline", type: "text", span: 2 },
      { key: "goal_label", label: "Cost line", type: "text", span: 2 },
      { key: "goal_amount", label: "Indicative cost ($)", type: "number" },
      { key: "kpl_alignment", label: "Kenya Premier League alignment", type: "textarea", span: 2 },
      { key: "revenue_note", label: "Revenue model note", type: "textarea", span: 2 },
      { key: "summary", label: "Summary", type: "textarea", span: 2 },
      { key: "body", label: "Detail (HTML supported)", type: "richtext", span: 2 },
      { key: "published", label: "Published", type: "switch" },
    ],

  },
  team: {
    label: "Position",
    columns: [
      ["order", "#"],
      ["role", "Position"],
      ["status", "Status"],
      ["published", "Live"],
    ],
    empty: { name: "", role: "", bio: "", status: "Vacant", order: 0, published: true },
    fields: [
      { key: "role", label: "Position title", type: "text", required: true, span: 2 },
      { key: "name", label: "Internal reference name", type: "text", required: true },
      { key: "status", label: "Status", type: "select", options: ["Vacant", "Filled"] },
      { key: "order", label: "Order", type: "number" },
      { key: "bio", label: "Responsibilities", type: "textarea", span: 2 },
      { key: "published", label: "Published", type: "switch" },
    ],

  },
  partners: {
    label: "Partner",
    columns: [
      ["order", "#"],
      ["name", "Name"],
      ["tier", "Tier"],
      ["published", "Live"],
    ],
    empty: { name: "", tier: "Official Partner", url: "", logo_url: "", order: 0, published: true },
    fields: [
      { key: "name", label: "Partner name", type: "text", required: true },
      { key: "tier", label: "Tier", type: "select", options: ["Official Partner", "Founding Partner", "Programme Partner", "Institutional Partner", "Technical Partner", "Partner"] },
      { key: "url", label: "Website", type: "text" },
      { key: "order", label: "Order", type: "number" },
      { key: "published", label: "Published", type: "switch" },
    ],
    

  },
  services: {    label: "Focus area",
    columns: [
      ["order", "#"],
      ["title", "Title"],
      ["icon", "Icon"],
      ["published", "Live"],
    ],
    empty: { title: "", description: "", icon: "Users", order: 0, published: true },
    fields: [
      { key: "title", label: "Title", type: "text", required: true },
      { key: "icon", label: "Lucide icon name", type: "text", placeholder: "Sprout" },
      { key: "order", label: "Order", type: "number" },
      { key: "description", label: "Description", type: "textarea", span: 2 },
      { key: "published", label: "Published", type: "switch" },
    ],

  },
  trainings: {
    label: "Training course",
    columns: [
      ["order", "#"],
      ["title", "Course"],
      ["track", "Track"],
      ["level", "Level"],
      ["published", "Live"],
    ],
    empty: { title: "", track: "Coaching", level: "Entry", provider: "", location: "Nairobi", duration: "", cost: "", description: "", outcomes: "", url: "", source: "KickStartKenyaFootball", order: 0, published: true },
    fields: [
      { key: "title", label: "Course title", type: "text", required: true, span: 2 },
      { key: "track", label: "Track", type: "select", options: ["Coaching", "Medical", "Analysis", "Business", "Operations", "Safeguarding", "Academy pathway"] },
      { key: "level", label: "Level", type: "select", options: ["Entry", "Intermediate", "Advanced"] },
      { key: "provider", label: "Provider", type: "text" },
      { key: "source", label: "Source organisation", type: "select", options: ["KickStartKenyaFootball", "FC Nairobi", "Crown Crane Park", "Kenya Premier League"] },
      { key: "location", label: "Location", type: "text" },
      { key: "duration", label: "Duration", type: "text" },
      { key: "cost", label: "Cost", type: "text" },
      { key: "order", label: "Order", type: "number" },
      { key: "url", label: "External link", type: "text" },
      { key: "description", label: "Description", type: "textarea", span: 2 },
      { key: "outcomes", label: "What you come away with", type: "textarea", span: 2 },
      { key: "published", label: "Published", type: "switch" },
    ],
  },
  jobs: {
    label: "Job",
    columns: [
      ["order", "#"],
      ["title", "Role"],
      ["discipline", "Discipline"],
      ["location", "Location"],
      ["published", "Live"],
    ],
    empty: { title: "", discipline: "Coaching", club: "", location: "Nairobi", contract: "Full time", salary: "", description: "", requirements: "", apply_email: "", apply_url: "", closes: "", source: "KickStartKenyaFootball", order: 0, published: true },
    fields: [
      { key: "title", label: "Role title", type: "text", required: true, span: 2 },
      { key: "discipline", label: "Discipline", type: "select", options: ["Coaching", "Medical", "Analysis", "Business", "Club administration", "Operations", "Community", "Media"] },
      { key: "club", label: "Club or organisation", type: "text" },
      { key: "source", label: "Source organisation", type: "select", options: ["KickStartKenyaFootball", "FC Nairobi", "Crown Crane Park", "Kenya Premier League"] },
      { key: "location", label: "Location", type: "text" },
      { key: "contract", label: "Contract", type: "select", options: ["Full time", "Part time", "Volunteer", "Internship", "Contract"] },
      { key: "salary", label: "Salary", type: "text" },
      { key: "closes", label: "Closing date", type: "text" },
      { key: "order", label: "Order", type: "number" },
      { key: "apply_email", label: "Application email", type: "text" },
      { key: "apply_url", label: "Application link", type: "text" },
      { key: "description", label: "Role description", type: "textarea", span: 2 },
      { key: "requirements", label: "Requirements", type: "textarea", span: 2 },
      { key: "published", label: "Published", type: "switch" },
    ],
  },
  counties: {
    label: "County",
    columns: [
      ["order", "#"],
      ["name", "County"],
      ["status", "Status"],
      ["published", "Live"],
    ],
    empty: { name: "", status: "Planned", note: "", programmes: "", order: 0, published: true },
    fields: [
      { key: "name", label: "County name", type: "text", required: true },
      { key: "status", label: "Status", type: "select", options: ["Facility in progress", "Proposal received", "Planned", "No activity yet"] },
      { key: "order", label: "Order", type: "number" },
      { key: "programmes", label: "Programmes (short list)", type: "text", span: 2 },
      { key: "gdp_ppp_usd_bn", label: "GDP PPP (US$ bn)", type: "text" },
      { key: "youth_population", label: "Youth 15-24", type: "text" },
      { key: "secondary_enrolment", label: "In secondary school", type: "text" },
      { key: "primary_enrolment", label: "In primary school", type: "text" },
      { key: "gdp_ppp_note", label: "GDP basis note", type: "text", span: 2 },
      { key: "note", label: "What is happening here", type: "textarea", span: 2 },
      { key: "published", label: "Published", type: "switch" },
    ],
  },
};
